import { type AdminConfigurationListParams, getAdminConfigurationListQueryOptions } from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { search: AdminConfigurationListParams };

export const configurationsQuery = ({ search }: QueriesInput) => getAdminConfigurationListQueryOptions(search);

export const queries = (input: QueriesInput): Array<WarmableQuery> => [configurationsQuery(input)];
